export default __webpack_public_path__ + "static/media/EAST3090.34I-39630_-23472_0.79bb3374.jpg";